import { createAction, props } from '@ngrx/store';
import { AppConfig, IntentConfig } from '../../../../app-view/api/v1/types';

/**
 * Actions für den App-Chooser-Dialog.
 */
export class AppChooserDialogActions {
  private static readonly prefix = '[Dialog App Chooser]';

  /**
   * Öffnet den Dialog mit Intent- und App-Konfigurationen.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
    props<{ intentConfig: IntentConfig; appConfigs: AppConfig[] }>(),
  );

  /**
   * Eine App wurde ausgewählt.
   */
  public static selectApp = createAction(
    `${this.prefix} Select app`,
    props<{ appConfig: AppConfig }>(),
  );

  /**
   * Schließt den Dialog ohne Auswahl.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
